import notifications, {
  toastFailure,  toastSuccess
} from '../../../global/notifications'
import { certificatesFetch, certificateClaim, types } from './'

export const certificatesDispatchers = (dispatch) => ({
  loadCertificates() {
    dispatch(certificatesFetch())
  },
  claimCertificate(tutorialSlug, name) {
    return dispatch(certificateClaim({ tutorialSlug, name })).then(
      ([, res]) => {
        if (res.type === types.CERTIFICATE_CLAIM_SUCCESS)
          toastSuccess(notifications.certificateClaim)
        else
          toastFailure(notifications.certificateClaim, res.payload)
        return res
      }
    )
  }
})

export default certificatesDispatchers
